import { DripDashboardPage } from '../../features/drip-campaigns/DripDashboardPage';

export function AdminDripCampaigns() {
  return <DripDashboardPage />;
}
